export default __webpack_public_path__ + "static/media/headshot-pradeep.efe9cc12.jpeg";